import React, { useEffect, useState } from "react";
import { BrowserRouter as Router, Routes, Route, Link } from "react-router-dom";

import Footer from "./main/footer";
import Nav from "./main/nav";
import NavTop from "./main/NavTop";
import "../App.css";
import { Bar, Line, Pie } from "react-chartjs-2";
import {
  Chart as ChartJS,
  Title,
  ArcElement,
  Tooltip,
  Legend,
  LineElement,
  PointElement,
  Filler,
  CategoryScale,
  LinearScale,
} from "chart.js";
import ImportRatioChart from "./import/ImportRetioChart";
import Swal from "sweetalert2";
import axios from "axios";
import ViewData from "./ViewData";
import { useLegendMapArea } from "./main/LegendMap";
import WarehouseData from "./WarehouseData";

ChartJS.register(
  ArcElement,
  Title,
  Tooltip,
  Legend,
  LineElement,
  PointElement,
  Filler,
  CategoryScale,
  LinearScale
);
export default function Index() {
  const [Data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [ImportChart, setImportChart] = useState([]);
  const [ExportChart, setExportChart] = useState([]);
  const [ModalType, setModalType] = useState(null);
  const [ModalDate, setModalDate] = useState(null);
  const [ModalData, setModalData] = useState(null);
  const [WarehouseModal, setWarehouseModal] = useState(null);

  const Colors = ["#00C49F", "#0088FE", "#FFBB28", "#FF8042"];

  const [DeStuffing, setDeStuffing] = useState({
    labels: null,
    datasets: [],
  });
  const [Delivery, setDelivery] = useState({
    labels: null,
    datasets: [],
  });
  const [Carting, setCarting] = useState({
    labels: null,
    datasets: [],
  });
  const [Stuffing, setStuffing] = useState({
    labels: null,
    datasets: [],
  });

  const GetData = async (date) => {
    setLoading(true);
    try {
      let url = `https://ctas.live/backend/api/warehouse/dashboard?date=${date}`;

      const response = await axios.get(url);
      if (response?.data?.status === "success") {
        setData(response?.data?.data);
      } else {
        Swal.fire({
          icon: "warning",
          title: "Oops!",
          text: "Something Went Wrong.",
        });
      }
    } catch (error) {
      Swal.fire({
        icon: "error",
        title: "Fetch Error!",
        text: error.message || "Something went wrong while fetching data.",
      });
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    const today = new Date();
    const yesterday = new Date(today);
    yesterday.setDate(today.getDate() - 1);
    const formattedDate = yesterday.toDateString();
    GetData(formattedDate);
  }, []);

  const { total: importData, loading: loading2 } = useLegendMapArea(
    "Import",
    "import"
  );
  const { total: exportData, loading: loading3 } = useLegendMapArea(
    "0",
    "export"
  );
  useEffect(() => {
    if (loading2 && loading3) return;
    const getSafeValue = (data, key) => Math.max(0, parseInt(data?.[key]) || 0);

    const importOccupied = getSafeValue(importData, "totalOccupiedSum");
    const importSpillOver = getSafeValue(importData, "totalSpillOverSum");
    const importHoldCargo = getSafeValue(importData, "totalHoldSum");
    const importAvailable = getSafeValue(importData, "totalAvailable");

    const exportOccupied = getSafeValue(exportData, "totalOccupiedSum");
    const exportSpillOver = getSafeValue(exportData, "totalSpillOverSum");
    const exportHoldCargo = getSafeValue(exportData, "totalHoldSum");
    const exportAvailable = getSafeValue(exportData, "totalAvailable");

    setImportChart([
      { name: "Spill Over", value: importSpillOver },
      { name: "Occupied", value: importOccupied },
      { name: "Hold Cargo", value: importHoldCargo },
      { name: "Available", value: importAvailable },
    ]);

    setExportChart([
      { name: "Spill Over", value: exportSpillOver },
      { name: "Occupied", value: exportOccupied },
      { name: "Hold Cargo", value: exportHoldCargo },
      { name: "Available", value: exportAvailable },
    ]);
  }, [importData, exportData]);

  useEffect(() => {
    if (!Data) return;

    if (Data?.weekly_de_stuffing) {
      Data.weekly_de_stuffing.sort(
        (a, b) => new Date(a.date_col) - new Date(b.date_col)
      );

      const chartData = {
        labels: Data.weekly_de_stuffing.map((item) => item.date_col.trim()), // Remove extra spaces in day names
        datasets: [
          {
            label: "DeStuffing",
            data: Data.weekly_de_stuffing.map((item) => Number(item.total)),
            backgroundColor: "rgba(171, 143, 230, 0.2)",
            borderColor: "#ab8fe6",
            borderWidth: 1,
            fill: true,
            tension: 0.3,
          },
        ],
      };
      // tension: 0.4,
      setDeStuffing(chartData);
    }
    if (Data?.weekly_delivery) {
      Data.weekly_delivery.sort(
        (a, b) => new Date(a.date_col) - new Date(b.date_col)
      );

      const chartData = {
        labels: Data.weekly_delivery.map((item) => item.date_col.trim()), // Remove extra spaces in day names
        datasets: [
          {
            label: "Delivery",
            data: Data.weekly_delivery.map((item) => Number(item.total)),
            backgroundColor: "rgba(255, 99, 132, 0.2)",
            borderColor: "#ff6384",
            borderWidth: 1,
            fill: true,
            tension: 0.3,
          },
        ],
      };
      // tension: 0.4,
      setDelivery(chartData);
    }
    if (Data?.weekly_carting) {
      Data.weekly_carting.sort(
        (a, b) => new Date(a.date_col) - new Date(b.date_col)
      );

      const chartData = {
        labels: Data.weekly_carting.map((item) => item.date_col.trim()), // Remove extra spaces in day names
        datasets: [
          {
            label: "Carting",
            data: Data.weekly_carting.map((item) => Number(item.total)),
            backgroundColor: "rgba(54, 162, 235, 0.2)",
            borderColor: "#36a2eb",
            borderWidth: 1,
            fill: true,
            tension: 0.3,
          },
        ],
      };
      // tension: 0.4,
      setCarting(chartData);
    }
    if (Data?.weekly_stuffing) {
      Data.weekly_stuffing.sort(
        (a, b) => new Date(a.date_col) - new Date(b.date_col)
      );

      const chartData = {
        labels: Data.weekly_stuffing.map((item) => item.date_col.trim()), // Remove extra spaces in day names
        datasets: [
          {
            label: "Stuffing",
            data: Data.weekly_stuffing.map((item) => Number(item.total)),
            backgroundColor: "rgba(255, 129, 66, 0.2)",
            borderColor: "#FF8042",
            borderWidth: 1,
            fill: true,
            tension: 0.3,
          },
        ],
      };
      // tension: 0.4,
      setStuffing(chartData);
    }
  }, [Data]);

  const option = {
    responsive: true,
    plugins: {
      legend: {
        position: "top",
      },
    },
    scales: {
      x: {
        beginAtZero: true,
      },
      y: {
        beginAtZero: true,
      },
    },
  };
  return (
    <>
      {loading && (
        <div
          className="d-flex justify-content-center align-items-center position-fixed top-0 start-0 w-100 h-100"
          style={{ zIndex: 9999 }}
        >
          <div className="sk-chase sk-primary display-1">
            <div className="sk-chase-dot" />
            <div className="sk-chase-dot" />
            <div className="sk-chase-dot" />
            <div className="sk-chase-dot" />
            <div className="sk-chase-dot" />
            <div className="sk-chase-dot" />
          </div>
        </div>
      )}
      <div className="layout-wrapper layout-without-menu">
        <div className="layout-container ">
          <div className="layout-page mt-5">
            <NavTop />
            <div className="content-wrapper">
              <div className="container-xxl flex-grow-1 container-p-y">
                <div className="row">
                  <div className=" col mb-6">
                    <Link to={"/import"}>
                      <div className="card card-border-shadow-primary h-100">
                        <div className="card-body">
                          <div className="d-flex justify-content-center mb-2">
                            <div className="avatar me-4">
                              <span className="avatar-initial rounded bg-label-primary">
                                <i className="ri-import-line ri-24px" />
                              </span>
                            </div>
                            <h4 className="mb-0">Import</h4>
                          </div>
                        </div>
                      </div>
                    </Link>
                  </div>
                  <div className=" col mb-6">
                    <Link to={"/export"}>
                      <div className="card card-border-shadow-warning h-100">
                        <div className="card-body">
                          <div className="d-flex justify-content-center mb-2">
                            <div className="avatar me-4">
                              <span className="avatar-initial rounded bg-label-warning">
                                <i className="ri-export-line ri-24px" />
                              </span>
                            </div>
                            <h4 className="mb-0">Export</h4>
                          </div>
                        </div>
                      </div>
                    </Link>
                  </div>
                </div>

                <div className="row gy-6">
                  <div className="col-lg-12">
                    <div className="card h-100">
                      <div className="card-header">
                        <div className="d-flex align-items-center justify-content-between">
                          <div className="">
                            <h5 className="card-title m-0 me-2">
                              Warehouse Reports
                            </h5>
                            <small className="d-block">
                              Since {Data?.startDateTime} to {Data?.endDateTime}
                            </small>
                            <small className="d-block">
                              On the basis of activity endtime
                            </small>
                          </div>
                          <div className="">
                            <label htmlFor="">Sort By Date</label>
                            <input
                              type="date"
                              className="form-control p-1"
                              defaultValue={Data.todayDate}
                              id="myDate"
                              onChange={(e) => {
                                GetData(e.target.value);
                              }}
                            />
                          </div>
                        </div>
                      </div>
                      <div className="card-body pt-lg-3">
                        <div className="row g-6">
                          <div className="col-md-3 col-6">
                            <div className="d-flex align-items-center">
                              <div
                                onClick={() =>
                                  setWarehouseModal({
                                    type: "de_stuffing",
                                    start: Data?.startDateTime,
                                    end: Data?.endDateTime,
                                  })
                                }
                                data-bs-toggle="modal"
                                data-bs-target="#warehouseData"
                                className="avatar"
                              >
                                <div className="avatar-initial bg-primary rounded shadow-xs">
                                  <i className="ri-pie-chart-2-line ri-24px"></i>
                                </div>
                              </div>
                              <div className="ms-3">
                                <p className="mb-0">DeStuffing</p>
                                <h5 className="mb-0">
                                  {Data?.tdy_de_stuffing}
                                </h5>
                              </div>
                            </div>
                          </div>
                          <div className="col-md-3 col-6">
                            <div className="d-flex align-items-center">
                              <div
                                onClick={() =>
                                  setWarehouseModal({
                                    type: "delivery",
                                    start: Data?.startDateTime,
                                    end: Data?.endDateTime,
                                  })
                                }
                                data-bs-toggle="modal"
                                data-bs-target="#warehouseData"
                                className="avatar"
                              >
                                <div className="avatar-initial bg-success rounded shadow-xs">
                                  <i className="ri-file-word-2-line ri-24px"></i>
                                </div>
                              </div>
                              <div className="ms-3">
                                <p className="mb-0">Delivery</p>
                                <h5 className="mb-0">{Data?.tdy_delivery}</h5>
                              </div>
                            </div>
                          </div>
                          <div className="col-md-3 col-6">
                            <div className="d-flex align-items-center">
                              <div
                                onClick={() =>
                                  setWarehouseModal({
                                    type: "carting",
                                    start: Data?.startDateTime,
                                    end: Data?.endDateTime,
                                  })
                                }
                                data-bs-toggle="modal"
                                data-bs-target="#warehouseData"
                                className="avatar"
                              >
                                <div className="avatar-initial bg-warning rounded shadow-xs">
                                  <i className="ri-macbook-line ri-24px"></i>
                                </div>
                              </div>
                              <div className="ms-3">
                                <p className="mb-0">Carting(Unloading)</p>
                                <h5 className="mb-0">{Data?.tdy_carting}</h5>
                              </div>
                            </div>
                          </div>
                          <div className="col-md-3 col-6">
                            <div className="d-flex align-items-center">
                              <div
                                onClick={() =>
                                  setWarehouseModal({
                                    type: "stuffing",
                                    start: Data?.startDateTime,
                                    end: Data?.endDateTime,
                                  })
                                }
                                data-bs-toggle="modal"
                                data-bs-target="#warehouseData"
                                className="avatar"
                              >
                                <div className="avatar-initial bg-info rounded shadow-xs">
                                  <i className="ri-money-dollar-circle-line ri-24px"></i>
                                </div>
                              </div>
                              <div className="ms-3">
                                <p className="mb-0">Stuffing</p>
                                <h5 className="mb-0">{Data?.tdy_stuffing}</h5>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div className="col-xl-12">
                    <div className="card-group">
                      <div className="card mb-0">
                        <div className="card-body card-separator">
                          <div className="d-flex justify-content-between align-items-center flex-wrap mb-4">
                            <h5 className="m-0 me-2">Import Cargo Overview</h5>
                            <Link to={"/import"} className="fw-medium" href="#">
                              View all
                            </Link>
                          </div>
                          <div className="deposit-content pt-2">
                            <ImportRatioChart
                              data={ImportChart}
                              COLORS={Colors}
                              isShowLegend={false}
                              isCustomLegend={true}
                            />
                          </div>
                        </div>
                      </div>
                      <div className="card mb-0">
                        <div className="card-body">
                          <div className="d-flex justify-content-between align-items-center flex-wrap mb-4">
                            <h5 className="m-0 me-2">Export Cargo Overview</h5>
                            <Link to={"/export"} className="fw-medium" href="#">
                              View all
                            </Link>
                          </div>
                          <div className="withdraw-content pt-2">
                            <ImportRatioChart
                              data={ExportChart}
                              COLORS={Colors}
                              isShowLegend={false}
                              isCustomLegend={true}
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div className="col-xl-6 col-md-12">
                    <div className="card">
                      <div className="card-header d-flex align-items-center justify-content-between">
                        <h4 className="card-title m-0 me-2">
                          DeStuffing Weekly Reports
                        </h4>
                      </div>
                      <div className="card-body pt-lg-8">
                        <Line data={DeStuffing} options={option} />
                      </div>
                    </div>
                  </div>

                  <div className="col-xl-6 col-md-12">
                    <div className="card">
                      <div className="card-header d-flex align-items-center justify-content-between">
                        <h4 className="card-title m-0 me-2">
                          Delivery Weekly Reports
                        </h4>
                      </div>
                      <div className="card-body pt-lg-8">
                        <Line data={Delivery} options={option} />
                      </div>
                    </div>
                  </div>

                  <div className="col-xl-6 col-md-12">
                    <div className="card">
                      <div className="card-header d-flex align-items-center justify-content-between">
                        <h4 className="card-title m-0 me-2">
                          Carting Weekly Reports
                        </h4>
                      </div>
                      <div className="card-body pt-lg-8">
                        <Line data={Carting} options={option} />
                      </div>
                    </div>
                  </div>

                  <div className="col-xl-6 col-md-12">
                    <div className="card">
                      <div className="card-header d-flex align-items-center justify-content-between">
                        <h4 className="card-title m-0 me-2">
                          Stuffing Weekly Reports
                        </h4>
                      </div>
                      <div className="card-body pt-lg-8">
                        <Line data={Stuffing} options={option} />
                      </div>
                    </div>
                  </div>

                  <div class="card-group">
                    <div class="card mb-0">
                      <div class="card-body card-separator  px-2">
                        <div class="d-flex justify-content-between align-items-center flex-wrap mb-4">
                          <h5 class="m-0 me-2  text-primary">
                            Top Importers By Volume
                          </h5>
                        </div>
                        <div class="deposit-content table-responsive">
                          <table class="table table-sm">
                            <thead>
                              <tr>
                                <th>SN.</th>
                                <th>Importer Name</th>
                                <th>No Of Container</th>
                              </tr>
                            </thead>
                            <tbody>
                              {Data?.importer &&
                                Object.entries(Data?.importer)?.map(
                                  ([importer, data], i) => {
                                    const tableColor = [
                                      "table-primary",
                                      "table-secondary",
                                      "table-success",
                                      "table-danger",
                                      "table-info",
                                      "table-primary",
                                      "table-secondary",
                                      "table-success",
                                      "table-danger",
                                      "table-info",
                                    ];
                                    return (
                                      <tr className={tableColor[i]} key={i}>
                                        <td>{i + 1}</td>
                                        <td>{importer}</td>
                                        <td>{data}</td>
                                      </tr>
                                    );
                                  }
                                )}
                            </tbody>
                          </table>
                        </div>
                      </div>
                    </div>
                    <div class="card mb-0">
                      <div class="card-body card-separator px-2">
                        <div class="d-flex justify-content-between align-items-center flex-wrap mb-4">
                          <h5 class="m-0 me-2 text-primary">
                            Top Exporters By Volume
                          </h5>
                        </div>
                        <div class="deposit-content">
                          <div class="table-responsive">
                            <table class="table table-sm">
                              <thead>
                                <tr>
                                  <th>SN.</th>
                                  <th>Exporter Name</th>
                                  <th>No Of Container</th>
                                </tr>
                              </thead>
                              <tbody>
                                {Data?.exporter &&
                                  Object.entries(Data?.exporter)
                                    ?.sort(
                                      (a, b) => b[1]?.length - a[1]?.length
                                    )
                                    ?.map(([exporter, data], i) => {
                                      const tableColor = [
                                        "table-primary",
                                        "table-secondary",
                                        "table-success",
                                        "table-danger",
                                        "table-info",
                                        "table-primary",
                                        "table-secondary",
                                        "table-success",
                                        "table-danger",
                                        "table-info",
                                      ];
                                      return (
                                        <tr className={tableColor[i]} key={i}>
                                          <td>{i + 1}</td>
                                          <td>{exporter}</td>
                                          <td>{data}</td>
                                        </tr>
                                      );
                                    })}
                              </tbody>
                            </table>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div className="col-lg-4 mb-2">
                    <div className="card">
                      <div className="card-header">
                        <h4 className="text-primary">EJO Report</h4>
                      </div>
                      <div className="card-body table-responsive px-1">
                        <table class="table">
                          <thead>
                            <tr>
                              <th scope="col">Previous Days Pending</th>
                              <th scope="col">No. of EJO Generated</th>
                              <th scope="col">Shifted</th>
                              <th scope="col">Total Pending</th>
                            </tr>
                          </thead>
                          <tbody>
                                  <tr>
                                    <td >{Data?.ejo?.pre_pending??0}</td>
                                    <td>{Data?.ejo?.total??0}</td>
                                    <td>{Data?.ejo?.completed??0}</td>
                                    <td>{(Data?.ejo?.pending+Data?.ejo?.pre_pending)??0}</td>
                                  </tr>
                              
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </div>
                  <div className=" col-lg-4 mb-2">
                    <div className="card">
                      <div className="card-header">
                        <h4 className="text-primary">SJO Report</h4>
                      </div>
                      <div className="card-body table-responsive px-1">
                        <table class="table">
                          <thead>
                            <tr>
                              <th scope="col">Previous Days Pending</th>
                              <th scope="col">No. of SJO Generated</th>
                              <th scope="col">Shifted</th>
                              <th scope="col">Total Pending</th>
                            </tr>
                          </thead>
                          <tbody>
                          <tr>
                                    <td >{Data?.sjo?.pre_pending??0}</td>
                                    <td>{Data?.sjo?.total??0}</td>
                                    <td>{Data?.sjo?.completed??0}</td>
                                    <td>{(Data?.sjo?.pending+Data?.sjo?.pre_pending)??0}</td>
                                  </tr>
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </div>
                  <div className=" col-lg-4 mb-2">
                    <div className="card">
                      <div className="card-header">
                        <h4 className="text-primary">Sealed Report</h4>
                      </div>
                      <div className="card-body table-responsive px-1">
                        <table class="table">
                          <thead>
                          <tr>
                              <th scope="col">Previous Days Pending</th>
                              <th scope="col">No. of WSL Generated</th>
                              <th scope="col">Shifted</th>
                              <th scope="col">Total Pending</th>
                            </tr>
                          </thead>
                          <tbody>
                              <tr>
                                    <td >{Data?.sealed?.pre_pending??0}</td>
                                    <td>{Data?.sealed?.total??0}</td>
                                    <td>{Data?.sealed?.completed??0}</td>
                                    <td>{(Data?.sealed?.pending+Data?.sealed?.pre_pending)??0}</td>
                                  </tr>
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </div> 
                  {/* <div className="col-lg-4 mb-2">
                    <div className="card">
                      <div className="card-header">
                        <h4 className="text-primary">EJO Report</h4>
                      </div>
                      <div className="card-body table-responsive px-1">
                        <table class="table">
                          <thead>
                          <tr>
                              <th scope="col">Date</th>
                              <th scope="col">Generated</th>
                              <th scope="col">Shifted</th>
                              <th scope="col">Pending</th>
                            </tr>
                          </thead>
                          <tbody>
                            {Data?.ejo_job_daily_stats &&
                              Object.entries(Data.ejo_job_daily_stats).map(
                                ([date, stats], index) => (
                                  <tr
                                    key={index}
                                    data-bs-toggle="modal"
                                    data-bs-target="#viewData"
                                    onClick={() => {
                                      setModalType("EJO");
                                      setModalDate(date);
                                      setModalData(`${date} EJO`);
                                    }}
                                  >
                                    <th scope="row">{date}</th>
                                    <td>{stats.total}</td>
                                    <td>{stats.pending}</td>
                                    <td>{stats.completed}</td>
                                  </tr>
                                )
                              )}
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </div>
                  <div className=" col-lg-4 mb-2">
                    <div className="card">
                      <div className="card-header">
                        <h4 className="text-primary">SJO Report</h4>
                      </div>
                      <div className="card-body table-responsive px-1">
                        <table class="table">
                          <thead>
                            <tr>
                              <th scope="col">Date</th>
                              <th scope="col">Generated</th>
                              <th scope="col">Shifted</th>
                              <th scope="col">Pending</th>
                            </tr>
                          </thead>
                          <tbody>
                            {Data?.sjo_job_daily_stats &&
                              Object.entries(Data.sjo_job_daily_stats).map(
                                ([date, stats], index) => (
                                  <tr
                                    key={index}
                                    data-bs-toggle="modal"
                                    data-bs-target="#viewData"
                                    onClick={() => {
                                      setModalType("SJO");
                                      setModalDate(date);
                                      setModalData(`${date} SJO`);
                                    }}
                                  >
                                    <th scope="row">{date}</th>
                                    <td>{stats.total}</td>
                                    <td>{stats.pending}</td>
                                    <td>{stats.completed}</td>
                                  </tr>
                                )
                              )}
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </div>
                  <div className=" col-lg-4 mb-2">
                    <div className="card">
                      <div className="card-header">
                        <h4 className="text-primary">Sealed Report</h4>
                      </div>
                      <div className="card-body table-responsive px-1">
                        <table class="table">
                          <thead>
                            <tr>
                              <th scope="col">Date</th>
                              <th scope="col">Generated</th>
                              <th scope="col">Shifted</th>
                              <th scope="col">Pending</th>
                            </tr>
                          </thead>
                          <tbody>
                            {Data?.sealed_job_daily_stats &&
                              Object.entries(Data.sealed_job_daily_stats).map(
                                ([date, stats], index) => (
                                  <tr
                                    key={index}
                                    data-bs-toggle="modal"
                                    data-bs-target="#viewData"
                                    onClick={() => {
                                      setModalType("Sealed");
                                      setModalDate(date);
                                      setModalData(`${date} Sealed`);
                                    }}
                                  >
                                    <th scope="row">{date}</th>
                                    <td>{stats.total}</td>
                                    <td>{stats.pending}</td>
                                    <td>{stats.completed}</td>
                                  </tr>
                                )
                              )}
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </div>  */}
                </div>
              </div>
              <div
                className="modal fade"
                id="warehouseData"
                tabIndex={-1}
                aria-labelledby="exampleModalLabel"
                aria-hidden="true"
              >
                <div className="modal-dialog modal-fullscreen">
                  <div className="modal-content">
                    <div className="modal-header bg-label-primary py-3">
                      <h1 className="modal-title fs-5" id="exampleModalLabel">
                        {WarehouseModal?.type?.toUpperCase()}
                      </h1>
                      <button
                        type="button"
                        className="btn-close"
                        data-bs-dismiss="modal"
                        aria-label="Close"
                      />
                    </div>
                    <div className="modal-body">
                      {WarehouseModal && (
                        <WarehouseData
                          type={WarehouseModal?.type}
                          start={WarehouseModal?.start}
                          end={WarehouseModal?.end}
                        />
                      )}
                    </div>
                    <div className="modal-footer  bg-label-primary py-3">
                      <button
                        type="button"
                        className="btn btn-secondary"
                        data-bs-dismiss="modal"
                      >
                        Close
                      </button>
                    </div>
                  </div>
                </div>
              </div>
              <div
                className="modal fade"
                id="viewData"
                tabIndex={-1}
                aria-labelledby="exampleModalLabel"
                aria-hidden="true"
              >
                <div className="modal-dialog modal-fullscreen">
                  <div className="modal-content">
                    <div className="modal-header bg-label-primary py-3">
                      <h1 className="modal-title fs-5" id="exampleModalLabel">
                        {ModalData?.toUpperCase()}
                      </h1>
                      <button
                        type="button"
                        className="btn-close"
                        data-bs-dismiss="modal"
                        aria-label="Close"
                      />
                    </div>
                    <div className="modal-body">
                      {ModalType && (
                        <ViewData type={ModalType} date={ModalDate} />
                      )}
                    </div>
                    <div className="modal-footer  bg-label-primary py-3">
                      <button
                        type="button"
                        className="btn btn-secondary"
                        data-bs-dismiss="modal"
                      >
                        Close
                      </button>
                    </div>
                  </div>
                </div>
              </div>

              <Footer />
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
